module.exports = __webpack_public_path__ + "static/phoneSystems-62c6defd6835b4668e1abbbc7eafaf0b.jpeg";